import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { EdmundsLogo } from 'client/site-modules/shared/components/edmunds-logo/edmunds-logo';

export function PoweredByEdmunds({ className }) {
  return (
    <div className={classnames('powered-by-edmunds d-flex justify-content-center align-items-center', className)}>
      <span className="size-10 d-inline-block me-0_25">Powered by</span>
      <EdmundsLogo path={null} />
    </div>
  );
}

PoweredByEdmunds.propTypes = {
  className: PropTypes.string,
};

PoweredByEdmunds.defaultProps = {
  className: '',
};
